import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const LightOutlineProfile: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8399 18.1932C19.8399 21.4892 15.3199 21.8702 11.9209 21.8702L11.6776 21.8699C9.51208 21.8647 3.99988 21.728 3.99988 18.1732C3.99988 14.9444 8.33823 14.5129 11.7114 14.4967L12.1641 14.4964C14.3295 14.5016 19.8399 14.6383 19.8399 18.1932ZM11.9209 15.9962C7.65988 15.9962 5.49988 16.7282 5.49988 18.1732C5.49988 19.6312 7.65988 20.3702 11.9209 20.3702C16.1809 20.3702 18.3399 19.6382 18.3399 18.1932C18.3399 16.7352 16.1809 15.9962 11.9209 15.9962ZM11.9209 1.99976C14.8489 1.99976 17.2299 4.38176 17.2299 7.30976C17.2299 10.2378 14.8489 12.6188 11.9209 12.6188H11.8889C8.96688 12.6098 6.59988 10.2268 6.60985 7.30676C6.60985 4.38176 8.99188 1.99976 11.9209 1.99976ZM11.9209 3.42776C9.77988 3.42776 8.03786 5.16876 8.03786 7.30976C8.03088 9.44376 9.75988 11.1838 11.8919 11.1918L11.9209 11.9058V11.1918C14.0609 11.1918 15.8019 9.44976 15.8019 7.30976C15.8019 5.16876 14.0609 3.42776 11.9209 3.42776Z"
        fill={props.fill || "currentColor" || "#224788"}
      />
    </svg>
  );
};

export default LightOutlineProfile;
